export default {
    extraSmall: 12,
    small: 14,
    medium: 16,
    large: 18,
    extraLarge: 20
};